<template>
    <b-modal ref="modal" size="xlg" lazy :hide-footer="true"
        :title="getTitle()" @hide="onHide" class="user-modal">

        <div slot="modal-title">
          {{ this.getTitle() }}
        </div>

        <div class="user-modal__content">
          <b-tabs>
            <b-tab title="Charts" active>
              <div class="charts">
                <b-row>
                  <b-col>
                    <UsageChart v-if="!this.isLoading" :chartData="this.usageChartData" height="300" />
                  </b-col>
                  <b-col>
                    <UsagePerIntegrationChart v-if="!this.isLoading" :chartData="this.upiChartData" height="300" />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <PostageChart v-if="!this.isLoading" :chartData="this.postageChartData" height="300" />
                  </b-col>
                  <b-col>
                    <SpentPerIntegrationChart v-if="!this.isLoading" :chartData="this.spiChartData" height="300" />
                  </b-col>
                </b-row>
              </div>
            </b-tab>

            <b-tab title="Shipments">
              <v-client-table ref="shipments_table" :columns="shipmentsTable.columns" :data="shipmentsTableData" :options="shipmentsTable.options">
                <div slot="actions" slot-scope="props">
                  <b-btn-group>
                    <b-btn variant="primary">Track</b-btn>
                    <b-btn variant="danger" :href="`/orders/${props.row.id}/label`" target="_blank">
                      <span class="fa fa-file-pdf-o"></span>
                    </b-btn>
                  </b-btn-group>
                </div>
              </v-client-table>
            </b-tab>

            <b-tab title="Support Tickets">

            </b-tab>
          </b-tabs>
        </div>

        
        
    </b-modal>
</template>

<style lang="scss">
.user-modal {
  .modal-body {
    padding: 0;
    max-height: 100%;
  }
  .nav-tabs .nav-link.active {
    border-top: none;
  }

  .charts {
    > .row + .row {
      margin-top: 30px;
    }
  }
}
</style>
<script>
import LoadingSpinner from '../../components/LoadingSpinner';
import OrderItems from '../../components/Orders/OrderItems';
import Alerts from '../../components/Alerts';
import { mapGetters, mapActions } from 'vuex';

import UsageChart from './charts/UserUsageChart';
import UsagePerIntegrationChart from './charts/UserUsagePerIntegrationChart';
import SpentPerIntegrationChart from './charts/UserSpentPerIntegrationChart';
import PostageChart from './charts/UserPostageChart';

import numeral from 'numeral';
import moment from 'moment';

export default {
  components: {
    LoadingSpinner,
    OrderItems,
    Alerts,
    UsageChart,
    UsagePerIntegrationChart,
    PostageChart,
    SpentPerIntegrationChart
  },
  props: ['user'],
  data() {
    return {
      isLoading: true,
      shipmentsTable: {
        columns: [
          'created_at',
          'order.integration.name',
          'order.shipping_service.name',
          'order.rate',
          'actions'
        ],
        options: {
          headings: {
            created_at: 'Date',
            'order.integration.name': 'Integration',
            'order.shipping_service.name': 'Shipping service',
            'order.rate': 'Postage paid'
          },
          sortable: [
            'created_at',
            'order.integration.name',
            'order.shipping_service.name',
            'order.rate'
          ],
          filterable: ['order.integration.name', 'order.shipping_service.name']
        }
      }
    };
  },
  computed: {
    usageChartData() {
      let data = [];
      let labels = [];

      let counts = {};

      this.user.labels.forEach(label => {
        let timestamp = moment(label.created_at).format('MMM Do YY');
        if (!counts[timestamp]) {
          counts[timestamp] = 1;
        } else {
          counts[timestamp]++;
        }
      });

      const countKeys = Object.keys(counts).sort();
      console.log('cc', countKeys);
      const firstDate = moment(countKeys[0], 'MMM Do YY');
      const lastDate = moment();

      for (
        let day = moment(firstDate);
        day.diff(lastDate, 'days') <= 0;
        day.add(1, 'days')
      ) {
        const timestamp = day.format('MMM Do YY');
        if (countKeys.includes(timestamp)) {
          data.push(counts[timestamp]);
          labels.push(timestamp);
        } else {
          data.push(0);
          labels.push(timestamp);
        }
      }

      return {
        labels: labels,
        datasets: [
          {
            label: 'Shipments',
            backgroundColor: '#ffc93a',
            data: data
          }
        ]
      };
    },
    upiChartData() {
      let data = [];
      let labels = [];

      let counts = {};

      this.user.labels.forEach(label => {
        const integration = this.user.integrations.find(integration => {
          return integration.id == label.order.integration_id;
        });
        if (!integration) return;

        counts[integration.name] = counts[integration.name] ? counts[integration.name] + 1 : 1;
      });

      Object.keys(counts).sort().forEach((integrationName) => {
        data.push(counts[integrationName])
        labels.push(integrationName)
      })

      return {
        labels: labels,
        datasets: [
          {
            label: 'Shipments',
            backgroundColor: '#ffc93a',
            data: data
          }
        ]
      };
    },
    spiChartData() {
      let data = [];
      let labels = [];
      Object.keys(this.user.spent_per_integration).forEach(integrationId => {
        const integration = this.user.integrations.find(integration => {
          return integration.id == integrationId;
        });
        if (!integration) return;

        let value = this.user.spent_per_integration[integrationId];

        labels.push(integration.name);
        data.push(value);
      });

      return {
        labels: labels,
        datasets: [
          {
            label: 'Spent by integration',
            backgroundColor: '#ff5454',
            data: data
          }
        ]
      };
    },
    postageChartData() {
      let data = [];
      let labels = [];

      let postage = {};
      let lastTimestamp = null;

      this.user.labels.forEach(label => {
        let timestamp = moment(label.created_at).format('MMM Do YY');
        if (!postage[timestamp] || !lastTimestamp) {
          postage[timestamp] = parseFloat(label.order.rate);
        } else {
          postage[timestamp] += parseFloat(label.order.rate);
        }
        lastTimestamp = timestamp;
      });

      const postageKeys = Object.keys(postage).sort();
      console.log('cc', postageKeys);
      const firstDate = moment(postageKeys[0], 'MMM Do YY');
      const lastDate = moment();
      let lastValue = null;

      for (
        let day = moment(firstDate);
        day.diff(lastDate, 'days') <= 0;
        day.add(1, 'days')
      ) {
        const timestamp = day.format('MMM Do YY');
        if (postageKeys.includes(timestamp)) {
          const value = lastValue ? postage[timestamp] + lastValue : postage[timestamp];
          data.push(value);
          labels.push(timestamp);
          lastValue = value;
        } else if(lastValue) {
          data.push(lastValue);
          labels.push(timestamp);
        }
      }

      console.log('cumu', data);

      return {
        labels: labels,
        datasets: [
          {
            label: 'Postage',
            backgroundColor: '#ff5454',
            data: data
          }
        ]
      };
    },
    shipmentsTableData() {
      return this.user.labels;
    }
  },
  created() {},
  mounted() {
    console.log('modal', this.$refs, this.user);
    this.$refs.modal.$on('shown', () => {
      this.isLoading = false;
    });
    this.$refs.modal.$on('hidden', () => {
      this.$destroy();
    });

    this.$refs.modal.show();
  },
  methods: {
    getTitle() {
      return this.getAttribute('name');
    },
    getAttribute(attribute, defaultVal = '') {
      return this.user[attribute] ? this.user[attribute] : defaultVal;
    },
    onHide() {
      this.$emit('hide');
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Admin/UserModal.vue